import { configureStore } from '@reduxjs/toolkit';
import categorySlice from '../Canteen/Items/CategorySlice';
import addItemsSlice from "../Canteen/Items/ItemsSlice";
import storeSlice from "../CanteenUsers/StoreSlice"
import stockSlice from '../Canteen/Stock/stockSlice';
import menuSlice from "../CanteenUsers/MenusSlice";
import checkoutSlice from "../CanteenUsers/OrderSlice"
import canteenTypeReducer from "../Canteen/Dashboard/canteenTypeSlice";
import comboOffersReducer from "../Canteen/Combo/ComboSlice";
import topSalesItemsReducer from "../Canteen/Report/ReportSlice";

const store = configureStore({
  reducer: {
    categories: categorySlice,
    items: addItemsSlice,
    store: storeSlice,
    stock: stockSlice,
    menus: menuSlice,
    orders:checkoutSlice,
    canteenType: canteenTypeReducer,
     comboOffers: comboOffersReducer,
      topSalesItems: topSalesItemsReducer,
      
  },
});

export default store;
